<template>
  <v-layout row align-start justify-space-between wrap :key="updateComponent">
    <div v-if="!editingData" class="specific-fields-view-container">
      <div v-for="field in fields" :key="field.varName" class="specific-field-view-container" :class="{ 'show-lines': !hideLines }">
          <v-icon v-if="field.icon">{{ field.icon }}</v-icon>
          <span>{{ field.label }}: </span><span>{{ field.value }}</span>
      </div>
    </div>

    <div v-if="editingData" class="card-info">
      <div
        v-for="field in fields"
        class="card-info-item-container"
        :key="field.label + ' - ' + field.varName"
        :style="[{ width: field.size ? field.size : 100/3+'%'}]"
      >
        <div class="card-info-item" :style="cardInfoItemStyling">
          <input-field
            :key="field.varName"
            :inputType="field.inputType"
            :value="field.value"
            :label="field.label"
            :input-disabled="field.disabled"
            :select-options="field.optionsListName"
            :select-options-list="field.options"
            :checkbox-options="field.checkboxOptions"
            :radio-options="field.radioOptions"
            :min="field.min"
            :max="field.max"
            :step="field.step"
            :size="'large'"
            :clearable="field.clearable"
            :required="field.required"
            :inputFieldContainerStyling="{ 'padding': '0'}"
            :checkbox-icon-style="field.checkboxIconStyle"
            :placeholder="field.placeholder"
            @input="$emit('update-field', { value: $event, field: field })"
          />
        </div>
      </div>
    </div>
  </v-layout>
</template>

<script>
import { listsMixin } from "@/mixins/listsMixin";
import InputField from "@/newComponents/_Atoms/InputField.vue";

export default {
  name: "FieldsList",

  components: {
    InputField,
  },

  mixins: [listsMixin],

  props: {
    /**
     * The specific fields values passed by the parent component
     */
    fields: {
      type: Array,
      required: true,
    },

    editingData: {
      type: Boolean,
      required: true,
    },

    updateComponent: {
      type: Number,
    },

    hideLines: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    cardInfoItemStyling() {
      return {
        'width': this.editingData ? '100%' : 'auto',
        'margin': !this.editingData ? '10px 12px 10px 0' : '6px 9px 6px 0'
      }
    },
      checkboxLabelStyle() {
        return {
        'font-size': '16px',
        'color': '#231E46',
        'font': 'Lato',
      }
      },
    },
}
</script>

<style scoped>
.text-in-between {
  margin: 0 10px;
}

.specific-field-view-container {
  text-align: left;
  padding: 12px 0 7.5px 0;
}

.specific-field-view-container span {
  color: #767676;
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 11.5px; /* 115% */
}

.specific-field-view-container span:last-child {
  font-weight: 700;
}

.specific-field-view-container.show-lines:not(:last-child) {
  border-bottom: 1px solid #DBDBE0;
}

.specific-fields-view-container {
  width: 100%;
}

.card-info {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  min-width: 100%;
}

.card-info-item-container {
  display: flex;
  flex-direction: row;
  gap: 13px;
}

.card-info-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 1px;
}

.v-icon {
  line-height: 0;
  color: #29BDF0;
  font-size: 15px;
  padding-right: 8px;
}
</style>


// WEBPACK FOOTER //
// src/newComponents/StockManagement/FieldsList.vue